/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap').default;

import { createApp } from 'vue';
import store from './store';
import dayjs from 'dayjs';
import { createBootstrap } from 'bootstrap-vue-next';
import SvgIcon from "vue3-icon"

// import bootstrap css 
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = createApp({});
//app.component('VueDatePicker', VueDatePicker);
app.component("svg-icon", SvgIcon);
app.use( createBootstrap() );
app.use( store );

// Import the individual components
import { 
            BTable,
            BCard, 
            BPagination, 
            BFormSelect, 
            BDropdown, 
            BDropdownItemButton, 
            BDropdownItem, 
            BFormCheckbox,
            BModal,
            BButton,
            BForm,
            BFormInput,
            BFormTextarea,
            BFormGroup,
            BTooltip,
            BFormRadioGroup
        } from 'bootstrap-vue-next'

// Add components globally
app.component('BTable', BTable)
app.component('BCard', BCard)
app.component('BPagination', BPagination)
app.component('BFormSelect', BFormSelect)
app.component('BDropdown', BDropdown)
app.component('BDropdownItemButton', BDropdownItemButton)
app.component('BDropdownItem', BDropdownItem)
app.component('BFormCheckbox', BFormCheckbox)
app.component('BModal', BModal)
app.component('BButton', BButton)
app.component('BForm', BForm)
app.component('BFormInput', BFormInput)
app.component('BFormTextarea', BFormTextarea)
app.component('BFormGroup', BFormGroup)
app.component('BTooltip', BTooltip)
app.component('BFormRadioGroup', BFormRadioGroup)

import DonationsDashboard from './components/donationsDashboard/donationsDashboard.vue'

app.component('donations-dashboard', DonationsDashboard);

app.config.globalProperties.$filters = {
    formatDate: function(dateString) {
        if (!dateString) {
          return ''
        }
        const date = dayjs(dateString);
        return date.format('MM/DD/YYYY');
    },
    formatDateTime: function(dateString) {
        if (!dateString) {
          return ''
        }
        const date = dayjs(dateString);
        return date.format('MM/DD/YYYY h:mm:ss a');        
    },
    formatNumber: function(number) {
      if (!number) {
        return ''
      }
      return number.toLocaleString('en')
    },    
    activityUser: function(activities){
        if (!Array.isArray(activities) || !activities.length) {
          return ''
        }

        let lastActivity = activities[activities.length - 1]

        if (lastActivity.causer === undefined) {
          return ''
        }

        if (lastActivity.causer === null) {
          return 'Unknown'
        }

        let user = lastActivity.causer
        if (user.first_name === undefined || user.first_name === null) {
          return 'Unknown'          
        }

        return user.first_name + ' ' + user.last_name
    },
    activityTime: function(activities){
      if (!Array.isArray(activities) || !activities.length) {
        return ''
      }

      let lastActivity = activities[activities.length - 1]

      if (lastActivity === undefined) {
        return ''
      }

      const date = dayjs(lastActivity.created_at);
      return date.format('MM/DD/YYYY');
    }     
}

app.mount('#app');